<template>
  <div class="underwriter-select">
    <h4 class="font-weight-bold mb-1">Full Data Export</h4>
    <p class="text-muted mb-4">Select the Lead Underwriter for which the export will be generated.</p>

    <div style="max-width: 420px">
      <label class="font-weight-bold mb-1">Lead Underwriter</label>
      <el-select
        v-model="selectedId"
        filterable
        placeholder="Search and select a Lead Underwriter"
        style="width: 100%"
        v-loading="isFetching"
      >
        <el-option
          v-for="uw in underwriters"
          :key="uw.id"
          :label="uw.name"
          :value="uw.id"
        />
      </el-select>
    </div>

  </div>
</template>

<script>
import { Select, Option } from 'element-ui'
import companiesService from '@services/companiesService'

export default {
  name: 'SaveReportWizardUnderwriterSelect',
  components: {
    'el-select': Select,
    'el-option': Option
  },
  props: {
    defaultRoleValue: {
      type: String,
      default: null
    },
    initialId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      underwriters: [],
      selectedId: null,
      isFetching: false
    }
  },
  async mounted() {
    this.isFetching = true
    try {
      // FDE dropdown must list only lead underwriters (lead status lives in
      // Lincoln; the backend resolves it when lead=true is passed).
      const response = await companiesService.lightweight({ role: 'Underwriter', lead: true })
      const list = (response.data && response.data.data) || []
      // Sort the lead underwriters alphabetically by name (case-insensitive).
      this.underwriters = list.slice().sort((a, b) =>
        String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' })
      )
      if (this.initialId) {
        this.selectedId = this.initialId
      } else if (this.defaultRoleValue) {
        const match = this.underwriters.find(uw => uw.role_value === this.defaultRoleValue)
        if (match) this.selectedId = match.id
      }
    } catch (e) {
      this.underwriters = []
    }
    this.isFetching = false
  },
  watch: {
    selectedId(id) {
      const uw = this.underwriters.find((u) => u.id === id) || null
      this.$emit('change', uw)
    }
  }
}
</script>
